import styled from 'styled-components';
import { breakpoints, fonts, pxToCssFont } from '@vfit/shared/themes';
import { Paragraph, Title } from '../../../Portability/portability.style';

export const ModalWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  .button-slide-container {
    margin-bottom: 16px;
  }
`;

export const ModalTitle = styled(Title)`
  text-align: left;

  @media (min-width: ${breakpoints.tablet}) {
    padding-top: 8px;
    ${pxToCssFont(30, 38)}
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding-top: 8px;
    ${pxToCssFont(36, 45)}
  }
`;

export const ModalDescription = styled(Paragraph)`
  font-family: ${fonts.regular};
  ${pxToCssFont(20, 26)}
  margin-top: 32px;
  text-align: left;

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(18, 24)}
  }
`;

export const ButtonDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-direction: column;

  @media (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
    gap: 20px;
  }

  .button-slide-container {
    width: 100%;

    @media (min-width: ${breakpoints.tablet}) {
      width: 258px;
    }

    @media (min-width: ${breakpoints.desktop}) {
      width: 296px;
    }
  }
`;

export const ButtonWrapper = styled.div`
  margin: 32px 20px;

  @media (min-width: ${breakpoints.tablet}) {
    margin: 64px 40px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    margin: 64px 55px;
  }

  .button-slide-container {
    @media (min-width: ${breakpoints.tablet}) {
      position: absolute;
      bottom: 64px;
      left: 40px;
      right: 40px;
    }

    @media (min-width: ${breakpoints.desktop}) {
      left: 55px;
      right: 55px;
    }
  }
`;
